export const CREATE_ADMIN_SOCIAL_CARE_NAVIGATOR = "CREATE_ADMIN_SOCIAL_CARE_NAVIGATOR";   
export const RETRIEVE_ADMIN_SOCIAL_CARE_NAVIGATOR = "RETRIEVE_ADMIN_SOCIAL_CARE_NAVIGATOR";
export const RETRIEVESINGLE_ADMIN_SOCIAL_CARE_NAVIGATOR = "RETRIEVESINGLE_ADMIN_SOCIAL_CARE_NAVIGATOR";
export const UPDATE_ADMIN_SOCIAL_CARE_NAVIGATOR = "UPDATE_ADMIN_SOCIAL_CARE_NAVIGATOR";   
export const DELETE_ADMIN_SOCIAL_CARE_NAVIGATOR = "DELETE_ADMIN_SOCIAL_CARE_NAVIGATOR";   
